export const fmtDate = (iso) =>
  iso ? new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }) : "—";

export const fullName = (a) => [a?.nom, a?.postnom, a?.prenom].filter(Boolean).join(" ");

export function computeCard(dateDelivrance) {
  if (!dateDelivrance) return { date_expiration: null, statut: "sans_carte", jours_restants: null };
  const d = new Date(`${dateDelivrance}T00:00:00`);
  const exp = new Date(d);
  exp.setFullYear(d.getFullYear() + 3);
  if (exp.getDate() !== d.getDate()) exp.setDate(0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = Math.round((exp - today) / 86400000);
  const pad = (n) => String(n).padStart(2, "0");
  const iso = `${exp.getFullYear()}-${pad(exp.getMonth() + 1)}-${pad(exp.getDate())}`;
  const statut = days < 0 ? "expiree" : days <= 60 ? "expire_bientot" : "valide";
  return { date_expiration: iso, statut, jours_restants: days };
}

export const STATUS = {
  valide: { label: "Valide", cls: "bg-emerald-500/15 text-emerald-800 border-emerald-300" },
  expire_bientot: { label: "Expire bientôt", cls: "bg-amber-500/15 text-amber-800 border-amber-300" },
  expiree: { label: "Expirée", cls: "bg-rose-500/15 text-rose-800 border-rose-300" },
  sans_carte: { label: "Sans carte verte", cls: "bg-slate-500/10 text-slate-700 border-slate-300" },
};
